import s from "./freightBlock.module.css";
import {formatPrice} from "../../../../../utils";
import {useAppContext} from "../../../../../contexts";

const FreightBlock = (props) => {
    // Destructured props
    const {data} = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Lists all the zip codes with assigned freight value
    const zipList =
        Object.entries(data.shippingPlaces).map(([key, value], index) => {
            return (
                <div
                    key={index}
                    className={'flex justify-between items-center'}
                >
                    <p className={`${s.zipLabel}`}>
                        CEP: {key}
                    </p>
                    <p className={`${s.price} ${highContrast ? "highLabelFirst" : ""}`}>
                        <span className={`text-sabin-red-default ${highContrast ? "highTitleThird" : ""}`}>
                            R$&nbsp;
                        </span>
                        {formatPrice(value)}
                    </p>
                </div>
            )
        });

    return (
        <div className={`${s.root}`}>
            <p className={`pb-2 font-extrabold text-black text-[16px] ${highContrast ? "highLabelFourth" : ""}`}>
                Taxa do serviço #VemSabin<br />
                Atendimento Móvel
            </p>
            {zipList}
        </div>
    )
}

export default FreightBlock;
